module.exports = __webpack_public_path__ + "img/go-tel-icon.8e22eab0.png";